// Match a GW system value (color/size) to a Lazada attribute option.
// Normalizes both sides: take the part after ':' (e.g. "Int:S" -> "S"),
// strip all whitespace, uppercase, then compare for exact equality.
// Returns the option's exact name (Lazada enum-validates), or '' when none matches.
const normalize = (value) => {
  const suffix = String(value ?? '').split(':').pop()
  return suffix.replace(/\s+/g, '').toUpperCase()
}

export default (systemValue, options) => {
  if (!systemValue || !Array.isArray(options)) return ''
  const match = options.find((option) => normalize(option.name) === normalize(systemValue))
  return match?.name || ''
}
